module.exports = __webpack_public_path__ + "img/right-product.0e04c529.svg";